module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/84aefa938153e51579474dadf72c525b.png";